<template>
  <div class="ui-content dashboard">
    <v-card class="mx-auto normal-card">
      <v-icon
        v-if="!showChapterInfo"
        class="back-icon pt-3"
        large
        @click="updateChart()"
      >
        double_arrow</v-icon
      >
      <h3 class="pt-3 text-center">Health Analysis: {{ data.studentName }}</h3>
      <hr />
      <div class="data-table-section health-report health-report">
        <v-row class="row-report">
          <v-col col="5" sm="5" class="col5-report">
            <div v-show="showChapterInfo && series1.length > 0">
              <div class="text-center chapter-health-title">
                {{ data.subject.name }}
              </div>
              <div class="text-center chapter-health-title">
                Health: {{ data.subject.healthPercentage + "%" }}
              </div>
              <PieChart
                :seriesData="series1"
                :height="pieChartHeight"
                :chartOptions="chartOptions1"
              />

              <!-- <apexchart
                                ref="chart1"
                                type="pie"
                                :height="pieChartHeight"
                                :options="chartOptions1"
                                :series="series1"
                            ></apexchart>-->
            </div>
            <div
              class="mt-5"
              v-show="
                !showChapterInfo && series1.length > 0 && series2.length > 0
              "
            >
              <div class="text-center chapter-health-title">
                {{ data.subject.name }}
              </div>
              <div class="text-center chapter-health-title">
                Health: {{ data.subject.healthPercentage + "%" }}
              </div>
              <PieChart
                :seriesData="series1"
                :height="150"
                :chartOptions="chartOptions1"
              />

              <div class="text-center chapter-health-title">
                {{ selectedChapter.name }}
              </div>
              <div class="text-center chapter-health-title">
                Health: {{ selectedChapter.healthPercentage + "%" }}
              </div>

              <PieChart
                :seriesData="series2"
                :height="150"
                :chartOptions="chartOptions2"
              />
            </div>
          </v-col>
          <v-col col="7" sm="7" class="col7-report">
            <div class="Chapterwise-scroll">
              <div class="proress-block-health">
                <div class="prog-plus-block">
                  <div
                    class="subject-details"
                    v-for="item in progressData"
                    :key="item.id"
                  >
                    <div class="subject-progress">
                      <div class="std-name">{{ item.name }}</div>
                      <v-progress-linear
                        :value="item.healthPercentage"
                        :height="25"
                        :color="getColor(item.healthPercentage)"
                        >{{ item.healthPercentage + "%" }}</v-progress-linear
                      >
                    </div>
                    <div
                      class="add-subject"
                      v-if="showChapterInfo"
                      @click="getTopicsData(item)"
                    >
                      <v-btn class="add-btn" fab>
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import PieChart from "@/components/Charts/PieChart.vue";

export default {
  props: ["onClose", "status", "data"],
  components: {
    PieChart,
  },
  mounted() {
    this.updateChart();
  },
  data() {
    return {
      showChapterInfo: true,
      pieChartHeight: 300,
      series1: [],
      chartOptions1: {
        legend: {
          show: false,
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "round",
          colors: "#000000",
          width: 0.5,
        },
        fill: {
          colors: ["#ffffff", "#ffffff"],
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -20,
              minAngleToShowLabel: 10,
            },
          },
        },
        dataLabels: {
          style: {
            fontSize: "13px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 500,
            colors: ["#000"],
          },
        },
      },

      series2: [],
      chartOptions2: {
        legend: {
          show: false,
        },
        fill: {
          colors: ["#ffbc80", "#ffffff"],
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -20,
              minAngleToShowLabel: 10,
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "round",
          colors: "#000000",
          width: 0.5,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          style: {
            fontSize: "13px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 500,
            colors: ["#000"],
          },
        },
      },
      progressData: [],
      selectedChapter: {},
    };
  },
  methods: {
    ...mapActions({
      getChapterWiseInfo: "resultStore/getChapterWiseInfo",
      getTopicWiseInfo: "resultStore/getTopicWiseInfo",
      getChildren: "resultStore/getChildren",
    }),
    updateChart() {
      this.getChapterOrTopic(this.data.subject.id);
      this.showChapterInfo = this.data.showChapterInfo;
      let healthPercentage = this.data.subject.healthPercentage;
      // healthPercentage = 0;
      let color = this.getColor(healthPercentage);
      let series = [healthPercentage, 100 - healthPercentage];
      this.series1 = series;
      // this.chartOptions1.fill.colors = [color, "#ffffff"];
      // this.$set(this.chartOptions1.fill, 'colors', [color, "#ffffff"])
      // this.$forceUpdate();

      // this.$refs.chart1.updateSeries(series, false, true);
      let chartColor = { fill: { colors: [color, "#ffffff"] } };
      this.chartOptions1 = { ...this.chartOptions1, ...chartColor };
    },
    updateTopicChart() {
      this.series1 = [];
      this.series2 = [];

      let healthPercentage = this.data.subject.healthPercentage;
      let color = this.getColor(healthPercentage);
      let series = [healthPercentage, 100 - healthPercentage];
      this.series1 = series;
      // this.chartOptions1.fill.colors = [color, "#ffffff"];
      let chartColor = { fill: { colors: [color, "#ffffff"] } };
      this.chartOptions1 = { ...this.chartOptions1, ...chartColor };

      let series2 = [
        this.selectedChapter.healthPercentage,
        100 - this.selectedChapter.healthPercentage,
      ];
      let color2 = this.getColor(series2[0]);

      this.series2 = series2;
      // this.chartOptions2.fill.colors = [color2, "#ffffff"];
      let chartColor2 = { fill: { colors: [color2, "#ffffff"] } };
      this.chartOptions2 = { ...this.chartOptions2, ...chartColor2 };

      this.showChapterInfo = false;

      // let chartColor = { fill: { colors: [color, "#ffffff"] } };
      // this.chartOptions2 = { ...this.chartOptions2, ...chartColor };

      // let healthPercentage = this.data.subject.healthPercentage;
      // color = this.getColor(healthPercentage);
      // series = [healthPercentage, 100 - healthPercentage];
      // this.$nextTick(() => {
      //     this.$refs.chart3.updateSeries(series, false, true);
      // });
    },
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    getTopicsData(chapter) {
      this.selectedChapter = chapter;
      this.updateTopicChart();
      this.getChapterOrTopic(chapter.id);
    },

    getChapterOrTopic(id) {
      let student_id = this.data.studentId;
      let me = this;
      let postData = {
        parent_id: [parseInt(id)],
        student_id: parseInt(student_id),
        required_health: 1,
      };
      this.$root.showLoader = true;
      this.getChildren(postData)
        .then((response) => {
          me.topics = response[0].chidren.map((t) => {
            return {
              name: t.title,
              id: t.id,
              healthPercentage: t.health,
            };
          });
          this.chapterName = response[0].title;
          this.$root.showLoader = false;
          this.progressData = me.topics;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
  },

  watch: {
    data: function(val) {
      this.updateChart();
    },
  },
};
</script>
